import { ReactNode } from 'react';
import {
  BriefcaseIcon,
  BuildingIcon,
  SquareUserIcon,
  StarIcon
} from 'stubben-edge-unified-frontend-react-components';
import { FavouriteItem } from '@/interfaces/Favourite.interface';
import { MenuGroupInterface, MenuItemInterface } from './types';

const ENTITY_ICONS: Record<FavouriteItem['type'], ReactNode> = {
  company: <BuildingIcon size={18} />,
  individual: <SquareUserIcon size={18} />,
  task: <BriefcaseIcon size={18} />,
  nav: <StarIcon size={18} />
};

function collectNavItems(
  groups: MenuGroupInterface[]
): MenuItemInterface[] {
  const items: MenuItemInterface[] = [];
  groups.forEach((group) => {
    group.items?.forEach((item) => {
      items.push(item);
      item.subItems?.forEach((sub) => {
        items.push(sub as MenuItemInterface);
      });
    });
  });
  return items;
}

export function resolveFavouriteIcon(
  favourite: FavouriteItem,
  navGroups?: MenuGroupInterface[]
): ReactNode {
  if (favourite.type === 'nav' && navGroups) {
    const match = collectNavItems(navGroups).find(
      (item) => item.link === favourite.path
    );
    if (match?.icon) return match.icon;
  }
  return ENTITY_ICONS[favourite.type] ?? <StarIcon size={18} />;
}
